import { progressBarConstants } from '~/components';
import { getDataForPiercingService } from '../helpers';

import { PATH_NAMES } from '../constants';

const { patterns, labels } = progressBarConstants;

const PIERCING_PAGE_TYPE = {
  pattern: patterns.PIERCING_TYPE_PAGE_PATTERN,
  label: labels.PIERCING_TYPE_PAGE_STEP_LABEL,
  props: { href: PATH_NAMES.PIERCING_TYPE },
};

const WELDING_PAGE_TYPE = {
  pattern: patterns.WELDING_TYPE_PAGE_PATTERN,
  label: labels.WELDING_TYPE_PAGE_STEP_LABEL,
  props: { href: PATH_NAMES.WELDING_TYPE },
};

const PIERCING_SERVICE_TYPE = getDataForPiercingService(PIERCING_PAGE_TYPE, WELDING_PAGE_TYPE);

export const PROGRESS_BAR_ITEMS = [
  {
    ...PIERCING_SERVICE_TYPE,
  },
  {
    pattern: patterns.SHOPS_PAGE_PATTERN,
    label: labels.SHOPS_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_SHOP },
  },
  {
    pattern: patterns.SELECT_DATE_PAGE_PATTERN,
    label: labels.SELECT_DATE_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_DATE },
  },
  {
    pattern: patterns.ABOUT_YOU_PAGE_PATTERN,
    label: labels.ABOUT_YOU_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.ABOUT_YOU },
  },
  {
    pattern: patterns.REVIEW_PAGE_PATTERN,
    label: labels.REVIEW_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.REVIEW },
  },
  {
    pattern: patterns.COMPLETE_PAGE_PATTERN,
    label: labels.COMPLETE_PAGE_STEP_LABEL,
    disableSiblings: true,
  },
];

export const EDIT_PROGRESS_BAR_ITEMS = [
  {
    pattern: patterns.EDIT_SHOP_PAGE_PATTERN,
    label: labels.SHOPS_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.EDIT_SHOP },
  },
  {
    pattern: patterns.EDIT_DATE_PAGE_PATTERN,
    label: labels.SELECT_DATE_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.EDIT_DATE },
  },
];
